// Vendor libraries
// NgRx actions
import { createReducer, on } from '@ngrx/store';
import { setComplianceReportHistoryStore } from '../compliance-report-data/compliance-report-data.actions';
import { setComplianceReportHistoryFilters } from '../filters/filters.actions';
import { setComplianceOwnerOption } from './owner.actions';
export const INITIAL_COMPLIANCE_OWNER_FILTER_STATE = { me: true, shared_with_me: true };
export const owner = createReducer(INITIAL_COMPLIANCE_OWNER_FILTER_STATE, on(setComplianceOwnerOption, (state, action) => {
    return { ...action.ownerOptions };
}), on(setComplianceReportHistoryFilters, (state, action) => {
    return { ...action.owner };
}), on(setComplianceReportHistoryStore, (state, action) => {
    return { ...action.owner };
}));
